import { render } from "./successFaceIcon.svg?vue&type=template&id=8ca38116"
const script = {}
script.render = render

export default script